export const USERTYPE_SET = 'USERTYPE_SET'
export const USERTYPE_RESET = 'USERTYPE_RESET'
export const COUNT_SET = 'COUNT_SET'
export const COUNT_RESET = 'COUNT_RESET'